module.exports = __webpack_public_path__ + "static/img/khadem.23e04a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/khadem.jpg
// module id = 483
// module chunks = 11